import { FileAddSVG } from '@components/icon/svg';
import { useFetchStudyReports, useGetStudy } from '@hooks/getQueries';
import { useAddToReport } from '@hooks/putQueries';
import usePermission from '@hooks/usePermission';
import { Icon } from '@iconify/react';
import { Box, Button, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

export const AddToReportButton = ({ name, description, isShowText = false }) => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [paginationModel] = useState({
    limit: 20,
    offset: 0,
    study_type: location.pathname.includes('dynamic-survey') ? 'dynamic_survey' : 'interview',
  });
  const { data: study } = useGetStudy(
    id,
    location.pathname.includes('dynamic-survey') ? 'dynamic_survey' : 'interview',
  );
  const { mutateAsync: addToReports } = useAddToReport();
  const { data: reports } = useFetchStudyReports({
    studyId: id,
    paginationModel,
    type: location.pathname.includes('dynamic-survey') ? 'dynamic_survey' : 'interview',
  });

  const {
    data: { studyPermission },
  } = usePermission({ study });

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAddToReport = async (reportId) => {
    const formData = {
      name: name,
      description: description,
    };
    await addToReports({ studyId: id, reportId, formData });
  };

  return (
    <>
      {isShowText ? (
        <Box>
          <Button size="small" variant="custom" sx={{ height: '36px' }} onClick={handleClick}>
            <Icon
              icon="material-symbols:add-notes"
              width="20"
              height="20"
              style={{ marginRight: '4px' }}
            />
            Add to Report
          </Button>
        </Box>
      ) : (
        <Tooltip
          title={
            studyPermission?.edit
              ? 'Add to custom report'
              : "You don't have permission to add to report"
          }
          disabled={!studyPermission?.edit}
        >
          <span>
            <IconButton onClick={handleClick} disabled={!studyPermission?.edit}>
              <FileAddSVG />
            </IconButton>
          </span>
        </Tooltip>
      )}

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {reports?.data?.length === 0 && <MenuItem disabled>No report available.</MenuItem>}
        {reports?.data?.length === 0 && (
          <MenuItem sx={{ p: 0 }}>
            <Button
              size="small"
              variant="contained"
              onClick={() =>
                navigate(
                  `/${location.pathname.includes('dynamic-survey') ? 'dynamic-survey' : 'interview'}/${id}/custom-reports`,
                  {
                    replace: true,
                    state: {
                      showAddToReportModal: true,
                    },
                  },
                )
              }
            >
              Add New Report
            </Button>
          </MenuItem>
        )}

        {reports?.data?.length > 0 &&
          reports?.data?.map((report) => (
            <MenuItem onClick={() => handleAddToReport(report.id)} key={report.id}>
              {report.title}
            </MenuItem>
          ))}
      </Menu>
    </>
  );
};
